module.exports = __webpack_public_path__ + "img/product_30.f8c8c63.svg";